// extracted by mini-css-extract-plugin
export var image = "DemoRequestBanner-module--image--23c84";
export var wrapper = "DemoRequestBanner-module--wrapper--67d75";